import React from "react";
import { MessageCircle } from "lucide-react";
import { useAnalytics } from "../hooks/useAnalytics";

const FloatingWhatsApp = () => {
  const { trackWhatsAppClick } = useAnalytics();

  const handleWhatsAppClick = () => {
    // Track the WhatsApp click (includes Google Ads conversion)
    trackWhatsAppClick('floating_button');

    const message = `Hallo! Ich interessiere mich für Ihre Malerarbeiten. Können Sie mir bitte ein Angebot machen?

Vielen Dank!`;

    const whatsappUrl = `https://wa.me/4915758183212?text=${encodeURIComponent(message)}`;
    // Use window.open for reliability - this always works even if tracking fails
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 animate-pulse md:hidden block"
      aria-label="WhatsApp kontaktieren"
    >
      <MessageCircle size={28} />
      <div className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
        <span className="text-xs font-bold text-white">!</span>
      </div>
    </button>
  );
};

export default FloatingWhatsApp;